import { Box, Center, Flex, Show, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import React from "react";

const leftSideIcons = [
  "/assets/chains/blast.svg",
  "/assets/chains/optimism.svg",
  "/assets/chains/base.svg",
  "/assets/chains/scroll.svg",
  "/assets/chains/arbitrum.svg",
];
const rightSideIcons = [
  "/assets/chains/linea.svg",
  "/assets/chains/zksync.svg",
  "/assets/chains/mode.svg",
  "/assets/chains/manta-pacific.svg",
  "/assets/chains/xlayer.svg",
];

const metrics = [
  {
    imgUrl: "/assets/institutions/why/liquidity.svg",
    text: "ON-CHAIN LIQUIDITY",
    value: "$130M+",
  },
  {
    imgUrl: "/assets/institutions/why/yield-optimiser.svg",
    text: "YIELD OPTIMISERS",
    value: "$70M+",
  },
  {
    imgUrl: "/assets/institutions/why/lending.svg",
    text: "LENDING PROTOCOLS",
    value: "$20M+",
  },
];

const assets = [
  {
    imgUrl: "/assets/eth.svg",
    text: "ETH",
    subText: "NATIVE",
  },
  {
    imgUrl: "/assets/stETH.svg",
    text: "stETH",
    subText: "LIDO",
  },
  {
    imgUrl: "/assets/ethx.svg",
    text: "ETHx",
    subText: "STADER",
  },
];

const partners = [
  "/assets/platforms/balancer.svg",
  "/assets/platforms/pendle.svg",
  "/assets/platforms/curve.svg",
  "/assets/platforms/gearbox.svg",
  "/assets/platforms/uni.svg",
  "/assets/platforms/penpie.png",
  "/assets/platforms/ramses.png",
  "/assets/platforms/prisma.png",
  "/assets/platforms/nile.jpg",
  "/assets/platforms/olive.jpg",
  "/assets/platforms/nuri.png",
];

const Why = () => {
  return (
    <Box
      maxWidth="1512px"
      w="100%"
      px={{ base: 5, md: 20 }}
      py={20}
      textAlign={"center"}
    >
      <Text fontSize={40} fontWeight={500}>
        Why Kelp?
      </Text>
      <Text fontSize={20} fontWeight={500} mt={3}>
        Kelp&apos;s rsETH is an industry leading LRT, available on Ethereum
        mainnet & 10 L2 networks.
      </Text>
      <Show above="md">
        <Flex
          my={16}
          alignItems="center"
          gap={3}
          justify="center"
          position="relative"
          _before={{
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: "450px",
            background: "linear-gradient(274deg, #DBF2F200 0%, #DBF2F2 100%)",
            zIndex: 1,
          }}
          _after={{
            content: '""',
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            width: "450px",
            background: "linear-gradient(86deg, #DBF2F200 0%, #DBF2F2 100%)",
            zIndex: 1,
          }}
        >
          {leftSideIcons.map((icon) => (
            <Box p={2} borderRadius="50%" key={icon} border="1px solid #93D1D1">
              <Box overflow="hidden" borderRadius="50%">
                <BaseImage height={60} width={60} src={icon} alt={icon} />
              </Box>
            </Box>
          ))}
          <Box mx={3}>
            <BaseImage
              height={107}
              width={107}
              src={"/assets/rseth.png"}
              alt={"rsETH"}
            />
          </Box>
          {rightSideIcons.map((icon) => (
            <Box p={2} borderRadius="50%" key={icon} border="1px solid #93D1D1">
              <Box overflow="hidden" borderRadius="50%">
                <BaseImage height={60} width={60} src={icon} alt={icon} />
              </Box>
            </Box>
          ))}
        </Flex>
      </Show>
      <Show below="md">
        <Flex
          my={16}
          alignItems="center"
          gap={3}
          justify="center"
          position="relative"
        >
          <Box mr={3}>
            <BaseImage
              height={107}
              width={107}
              src={"/assets/rseth.png"}
              alt={"rsETH"}
            />
          </Box>
          {leftSideIcons.map((icon) => (
            <Box p={2} borderRadius="50%" key={icon} border="1px solid #93D1D1">
              <Box overflow="hidden" borderRadius="50%">
                <BaseImage height={60} width={60} src={icon} alt={icon} />
              </Box>
            </Box>
          ))}
        </Flex>
      </Show>

      <Flex
        width={"100%"}
        flexDir={{ base: "column", md: "row" }}
        gap={6}
        justify="center"
        mb={16}
      >
        {metrics.map((metric) => (
          <Center
            key={metric.text}
            gap={3}
            flexDir={"column"}
            alignItems={{ base: "flex-start", md: "center" }}
          >
            <BaseImage
              src={metric.imgUrl}
              alt={metric.text}
              width={32}
              height={32}
            />
            <Text fontSize={18} fontWeight={500}>
              {metric.text}
            </Text>
            <Text fontSize={32} fontWeight={500} color="#142528">
              {metric.value}
            </Text>
          </Center>
        ))}
      </Flex>
      <Box>
        <Text fontSize={18} textAlign={{ base: "left", md: "inherit" }}>
          Kelp accepts deposits from major LSTs & ETH
        </Text>
        <Flex
          mt={6}
          width={"100%"}
          flexDir={{ base: "column", md: "row" }}
          gap={6}
          justify="center"
          mb={16}
        >
          {assets.map((asset) => (
            <Flex
              w={221}
              p={3}
              key={asset.text}
              gap={3}
              justify={"space-between"}
              alignItems="center"
              border="0.5px solid #6AC4F6"
              borderRadius={"9px"}
              boxShadow={"0px 5px 11px rgba(0, 0, 0, 0.10)"}
            >
              <Box textAlign="left">
                <Text
                  fontSize={24}
                  lineHeight={"100%"}
                  fontWeight={600}
                  color="#142528"
                >
                  {asset.text}
                </Text>
                <Text
                  mt={1}
                  fontWeight={600}
                  lineHeight={"100%"}
                  color="#A1B6BA"
                >
                  {asset.subText}
                </Text>
              </Box>
              <BaseImage
                src={asset.imgUrl}
                alt={asset.text}
                width={44}
                height={44}
              />
            </Flex>
          ))}
        </Flex>
      </Box>
      <Center flexDir={"column"}>
        <Text fontSize={18} textAlign={{ base: "left", md: "inherit" }}>
          rsETH is available on multiple DeFi protocols, DEXs, CEXs, & wallets
        </Text>
        <Flex
          mt={6}
          maxW={{ md: 424 }}
          width={"100%"}
          gap={6}
          justify={{ md: "center" }}
          flexWrap={"wrap"}
        >
          {partners.map((partner) => (
            <Box
              textAlign="left"
              key={partner}
              borderRadius={"50%"}
              overflow="hidden"
            >
              <BaseImage src={partner} alt={partner} width={50} height={50} />
            </Box>
          ))}
        </Flex>
      </Center>
    </Box>
  );
};

export default Why;
